export default __webpack_public_path__ + "static/media/Libra.5eff38d1.svg";